import {
  sorryUnableTo,
  DEFAULT_PROBLEM_TITLE,
  TRY_AGAIN_LATER_MESSAGE,
  TECH_GLITCH_MESSAGE
} from "./constants";

export function createUIMessage(message: string, actionMessage: string): [string[], string] {

  const messages = new Array<string>();
  if (message){
    messages.push(message);
  } else {
    messages.push(sorryUnableTo(actionMessage), TECH_GLITCH_MESSAGE, TRY_AGAIN_LATER_MESSAGE);
  }
  return [messages, DEFAULT_PROBLEM_TITLE];

}
